const create = {
  path: 'create',
  component: resolve => require(['@/pages/admin/merchant/signing/yftAlipay/accessPay/create'], resolve)
}

export default create
